<template>
    <a-modal title="单位信息"
             :width="1000"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="$emit('cancel')"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <table style="width:80%;height: 380px;" >
            <tr>
                <th>单位名称：</th>
                <td>
                    {{en.enterpriseName}}
                </td>
                <th>注册号：</th>
                <td>
                    {{en.enterpriseCode}}
                </td>
            </tr>

            <tr>
                <th>负责人：</th>
                <td>
                    {{en.legalPerson}}
                </td>
                <th>负责人身份证：</th>
                <td>
                    {{en.legalIdCard}}
                </td>
            </tr>

            <tr>
                <th>手机号：</th>
                <td>
                    {{en.contactsPhone}}
                </td>
                <th>经营范围：</th>
                <td>
                    {{en.businessScope}}
                </td>
            </tr>
            <tr>
                <th>注册时间：</th>
                <td>
                    {{en.foundDate}}
                </td>
                <th>注册地址：</th>
                <td>
                    {{en.registerAddress}}
                </td>
            </tr>

            <tr>
                <th>邮箱：</th>
                <td>
                    {{en.email}}
                </td>
                <th>办公电话/电子邮件：</th>
                <td>
                    {{en.tel}}
                </td>
            </tr>
            <tr>
                <th>
                    营业执照扫描件:
                </th>
                <td>
                    <upload-selector
                            :referId='en.cmtId'
                            ref="UploadSelector"
                            :max="1"
                            :readonly="true"
                            value="license"
                            configKey='UCARD'/>
                </td>
                <th>&nbsp;</th>
                <td>&nbsp;</td>
            </tr>
        </table>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from "moment";

    export default {
        created() {
            this.initInfo()
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        components: {
            UploadSelector,
            moment
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                pca: pca,
                pcaa: pcaa,
                modalLoading: false,
                params: {},
                loading: false,
                supplier: '',
                city: '',
                province: '',
                district: '',
                en: '',
                // selected:[pcaa[86]['110000'],pcaa['110000']['110100'],pcaa['110100']['110101']]
                selected: []
            }
        },
        methods: {
            initInfo() {
                let that = this
                this.$http.get("/api/v1/supplier/enterprise/init_certifications.json").then(function (res) {
                    // console.log("init_certifications")
                    console.log(res)
                    that.en = res.result
                    if (that.en.foundDate) {
                        that.en.foundDate = moment(that.en.foundDate).format("YYYY/MM/DD")
                    }
                    if (that.en.registerCapital){
                        that.en.registerCapital = that.en.registerCapital + ""
                    }
                })}
        }
    };
</script>
<style lang="less" scoped>
    .ant-input {
        width: 300px;
    }

    .fx-form th {
        width: 130px;
    }
    /*table {*/
    /*    height: 400px;*/
    /*}*/
    th{
        width: 150px;
    }
    tr{
        height: 70px;
    }
</style>
